import { cn } from '@/design-system/lib/cn';

import BrandLogo from './BrandLogo';

/**
 * O ícone do aplicativo instalado: o símbolo colorido num quadrado branco, também no tema
 * escuro (é o ícone que vai para a tela do celular). Decorativo — o nome vem ao lado.
 * O tamanho e o raio do quadrado vêm de `className`; o do símbolo, de `logoClassName`.
 */
export default function AppIcon({
  className,
  logoClassName,
}: {
  className?: string;
  logoClassName?: string;
}) {
  return (
    <span aria-hidden className={cn('grid shrink-0 place-items-center bg-white scheme-light', className)}>
      <BrandLogo tone="light" decorative className={cn('h-[70%] w-auto max-w-[80%]', logoClassName)} />
    </span>
  );
}
